<!DOCTYPE html>
<!--[if IE 8 ]><html class="ie" xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US"> <![endif]-->
<!--[if (gte IE 9)|!(IE)]><!-->
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US">
<!--<![endif]-->

<head>


</head>

<body class="body popup-loader counter-scroll">

  <!-- wrapper -->
  <div id="wrapper">

    <!-- page-title -->
    <div class="page-title">
      <div class="tf-tsparticles">
        <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
      </div>
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <h1 class="title">Cookie Policy</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /page-title -->
    <div class="main-content">
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <ul class="">
                <div>
                  <p>Like most websites, this one uses cookies. <br />
                    Cookies are small text files stored on your computer by your browser. They're used for many things,
                    such as remembering whether you've visited the site before, so that you remain logged in - or to
                    help us
                    work out how many new website visitors we get each month. They contain information about the use of
                    your
                    computer but don't include personal information about you (they don't store your name, for
                    instance). This policy explains how cookies are used on this websites in general &ndash; and, below,
                    how you
                    can control the cookies that may be used on this site (not all of them are used on every site).
                  </p>
                  <br />
                  <br />
                  <div class="content">
                    <h2 class="title mb-6">Our use of cookies</h2>
                    <p>We may collect information automatically when you visit the Website, using cookies.<br />
                      The cookies allow us to identify your computer and find out details about your last visit.<br />
                      You can choose, below, not to allow cookies. If you do, we can&rsquo;t guarantee that your
                      experience with the Website will be as good as if you do allow cookies. The information collected
                      by cookies does not personally identify you; it includes general
                      information about your computer settings, your connection to the Internet e.g. operating system
                      and platform,
                      IP address, your browsing patterns and timings of browsing on the Website and your location.<br />
                      Most internet browsers accept cookies automatically, but you can change the settings of your
                      browser to
                      erase cookies or prevent automatic acceptance if you prefer.
                      The following section of links explain how you can control cookies via your browser &ndash;
                      remember that if you turn
                      off
                      cookies in your browser then these settings apply to all websites not just this one.<br /><br />

                      <li><a href="http://support.google.com/chrome/answer/95647?hl=en-GB" target="_blank">Chrome</a>
                      </li>

                      <li><a href="https://support.apple.com/kb/PH17191" target="_blank">Safari</a></li>
                      <li><a href="https://support.apple.com/en-us/HT201265" target="_blank">iPhone, iPad, or iPod
                          touch</a></li>
                      <li><a
                          href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences?redirectlocale=en-US&redirectslug=Enabling+and+disabling+cookies"
                          target="_blank">Firefox</a></li>
                      <li><a
                          href="https://support.microsoft.com/en-gb/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                          target="_blank">Edge</a></li>
                      <li><a href="http://www.opera.com/help/tutorials/security/" target="_blank">Opera</a></li>

                      <li><a
                          href="https://support.google.com/accounts/answer/61416?hl=en&co=GENIE.Platform%3DAndroid&oco=1"
                          target="_blank">Android</a></li>
                      <li><a href="http://support.microsoft.com/kb/278835" target="_blank">Internet Explorer</a></li>

                      <li><a
                          href="http://www.windowsphone.com/en-us/how-to/wp7/web/changing-privacy-and-other-browser-settings"
                          target="_blank">Internet Explorer – Mobile</a></li>
                      <br /><br />
                    <h2 class="title mb-6">Cookies used</h2>
                    <div>Types of cookie that may be used during your visit:</div>
                    <p>The following types of cookie are used on this website:
                      <br />
                      cb_enabled<br />
                      __cf_bm<br />

                      We don't list every other single cookie used by name but for each type of cookie we tell you how
                      you
                      can
                      control its use.
                      <br /><br />

                    <h2 class="title mb-6">Analytics cookies</h2>

                    <p>These anonymously monitor how visitors move around the Website and how they reached it. This is
                      used so
                      that I can see total (not individual) figures on which types of content users enjoy most, for
                      instance.<br /><br />
                      Google Analytics cookies are:
                    <div>
                      <ul>
                        <li>_ga: used to distinguish users; duration: 2 years</li>
                        <li>_ga_&lt;container-id&gt;: used to persist session state: 2 years</li>
                      </ul>
                    </div>
                    <br /><br />
                    You can opt out of these if you want:<br /><br />
                    <div>
                      <ul>
                        <li><a href="https://support.google.com/accounts/answer/61416?hl=it&co=GENIE.Platform%3DDesktop"
                            target="_blank">Google</a></li><br />
                        <li><a
                            href="https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out"
                            target="_blank">Google Analytics</a></li><br />
                        <li><a href="https://www.google.com/policies/technologies/cookies/" target="_blank">Google
                            cookie
                            policy</a></li><br />
                        <li><a href="http://www.adobe.com/privacy/analytics.html#optout" target="_blank">Omniture</a>
                        </li>
                      </ul>
                    </div>
                    <br /><br />
                    <h2 class="title mb-6">Third-party service cookies</h2>

                    <p>Social sharing, video and other services we offer are run by other companies. These companies may
                      drop
                      cookies
                      on your computer when you use them on our site or if you are already logged in to them.<br />
                      Here is a list of places where you can find out more about specific services that we may use and
                      their
                      use of
                      cookies:<br /><br />
                    <div>
                      <ul>
                        <li><a href="https://discord.com/terms/privacy-policy" target="_blank">Discord Privacy
                            Policy</a>
                        </li><br />
                        <li><a href="https://telegram.org/privacy?setln=en" target="_blank">Telegram Messenger Privacy
                            Policy</a></li>
                      </ul>
                    </div>



                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- /wrapper -->